module.exports = __webpack_public_path__ + "img/tuji.19a7bf96.png";